import type { UiKey } from "../i18n/ui";
import type { ComputeProfileId } from "../lib/computeProfile";

type Props = {
  t: (key: UiKey) => string;
  value: ComputeProfileId;
  onChange: (p: ComputeProfileId) => void;
};

const ORDER: ComputeProfileId[] = ["cpu", "gpu"];
const LABEL: Record<ComputeProfileId, UiKey> = {
  cpu: "computeProfile.cpu",
  gpu: "computeProfile.gpu",
};

export function ComputeProfilePanel({ t, value, onChange }: Props) {
  return (
    <div className="compute-profile">
      <h2>{t("computeProfile.title")}</h2>
      <p className="hint">{t("computeProfile.hint")}</p>
      <div className="tabs" role="tablist" aria-label={t("computeProfile.title")}>
        {ORDER.map((key) => (
          <button
            key={key}
            type="button"
            role="tab"
            aria-selected={value === key}
            className={value === key ? "tab active" : "tab"}
            onClick={() => onChange(key)}
          >
            {t(LABEL[key])}
          </button>
        ))}
      </div>
      <style>{`
        .compute-profile h2 {
          font-size: 1rem;
          margin: 0 0 0.35rem;
        }
        .compute-profile .hint {
          margin: 0 0 0.65rem;
          font-size: 0.82rem;
          color: var(--muted);
          line-height: 1.45;
        }
        .compute-profile .tabs {
          display: flex;
          flex-wrap: wrap;
          gap: 0.5rem;
        }
        .compute-profile .tab {
          border: 1px solid var(--border);
          background: var(--surface2);
          color: var(--muted);
          padding: 0.35rem 0.75rem;
          border-radius: 8px;
          cursor: pointer;
          font: inherit;
          font-size: 0.88rem;
          font-weight: 600;
        }
        .compute-profile .tab.active {
          border-color: var(--accent-dim);
          color: var(--text);
          background: var(--accent-chip);
        }
        .compute-profile .tab:focus-visible {
          outline: 2px solid var(--accent);
          outline-offset: 2px;
        }
      `}</style>
    </div>
  );
}
